import { useOnEvent } from './use-on-event';

export const useOnKeyDown = (
  listener: (e: KeyboardEvent) => void,
  deps?: unknown[],
) => {
  useOnEvent('keydown', listener, deps);
};
